import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import {
    useStylesUiElemment,
} from '../../../../../St/Reports/UseStyle';
import { Button, colors } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import { Save } from '@material-ui/icons';

export default function ItemsCompsForm(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        newItemComp,
        khamsItems,
        onSubmit,
        onChangeData,
        onChangeAutoData,
    } = props;


    const clasui = useStylesUiElemment();

    const onChangeSearch = (event) => {
        //  event.preventDefault();
        onSubmit();
    };
    return (
        <React.Fragment>

            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={5} md={3} sm={4} xs={6} >
                    <Autocomplete
                        value={newItemComp.item}
                        labelPlacement=""
                        onChange={(event, newValue) => {
                            onChangeAutoData("item", newValue);
                            document.getElementById("mat_quan").focus();

                        }}
                        id="controllable-states-demo"
                        size="small"
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        options={khamsItems}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name??option.symbol
                        }
                        disableClearable={true}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("forms:item")}
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item lg={2} md={3} sm={4} xs={4} >
                    <Autocomplete
                        value={newItemComp.defUnit}
                        labelPlacement=""
                        onChange={(event, newValue) => {
                            onChangeAutoData("unit", newValue);
                            document.getElementById("mat_quan").focus();

                        }}
                        id="unit"
                        size="small"
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        options={newItemComp.units}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.unitName
                        }
                        disableClearable={true}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("forms:unit")}
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                </Grid>

                <Grid item lg={2} md={3} sm={3} xs={4} >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="mat_quan"
                        label={t("forms:quanity")}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="mat_quan"
                        value={newItemComp.mat_quan}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onSubmit(event);
                                }
                            },
                        }}
                        onChange={onChangeData("mat_quan")} />
                </Grid>

                <Grid item lg={2} md={3} sm={3} xs={4} >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="price"
                        label={t('forms:price')}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="price"
                        value={newItemComp.price}
                        InputProps={{ readOnly: true }}
                    />
                </Grid>

                <Grid item lg={1} md={1} sm={1} xs={2} >
                    <Grid item>

                        <Button
                            disabled={false}
                            variant="contained"
                            startIcon={<Save />}
                            size="large"
                            color='#fff'
                            style={{ backgroundColor: '#cd5c5c', borderRadius: 0, color: '#fff' }}
                            className={[clasui.buttonB]}
                            onClick={(event) => onSubmit(event)}
                        >
                        </Button>
                    </Grid>
                </Grid>

            </Grid>

        </React.Fragment >
    );

}